import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { findError, validationClasses } from '@/utils/errors';
import fields, { globalFieldLengths } from '@/constants/fields';
import ValidationSpan from '@/components/errors/ValidationSpan';
import { updateCollectionProperties } from '../actions';
import CollectionFieldInput from '../components/CollectionFieldInput';
import CollectionFieldHeader from './CollectionFieldHeader';
import { collectionPermissions } from '../sharing/constants';

const CollectionName = ({
  canEdit,
  category,
  code,
  errorCoordinate = 't-30',
  isEditing,
  name,
  updateName,
  validationErrors,
}) => {
  const validationError = findError(validationErrors, 'collection', [fields.NAME]);

  return (
    <>
      {!isEditing && (
        <CollectionFieldHeader
          code={code}
          category={category}
          value={name}
          icon="object group outline"
          canEdit={canEdit}
        />
      )}
      {canEdit && isEditing && (
        <>
          <ValidationSpan validationError={validationError} position="bottom" errorCoordinate={errorCoordinate} />
          <CollectionFieldInput
            text={name}
            type="name"
            maxLength={globalFieldLengths.name}
            onChange={(value) => updateName(category, code, value)}
            icon="object group outline"
            iconPosition="left"
            size="huge"
            className={validationClasses(validationError, 'aridhia-collection-title')}
          />
        </>
      )}
    </>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { collections: { update } } } },
  collections: { collections },
}, { category, code }) => {
  const item = findResult(collections, category, code) || { isEditing: false, permissions: {} };

  return (
    {
      name: item.name,
      isEditing: item.isEditing,
      canEdit: update || (item.permissions[collectionPermissions.UPDATE]),
      validationErrors: item.saveErrors,
    }
  );
};

const mapDispatchToProps = {
  updateName: (category, code, value) => updateCollectionProperties(category, code, { name: value }),
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionName);
